import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import ProfileRepository from '../../repositories/ProfileRepository';
import ProfileDataRepository from '../../../data/repositories/ProfileDataRepository';

export function getImageBase64(url: string): Promise<string> {
  return fetch(url)
    .then((response) => response.blob())
    .then(
      (blob) =>
        new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
}

export default function* execute(): any {
  try {
    yield put({ type: Types.GET_PROFILE_PHOTO_REQUEST });
    const profileRepository: ProfileRepository = new ProfileDataRepository();
    const profileResponse = yield call(profileRepository.getProfilePhoto);
    const imgBase64 = yield call(getImageBase64, profileResponse);
    yield put({
      type: Types.GET_PROFILE_PHOTO_SUCCESS,
      data: imgBase64
    });
  } catch (error) {
    yield put({
      type: Types.GET_PROFILE_PHOTO_FAILURE,
      error: true
    });
  }
}
